export enum ResultOptionEnum {
  Add,
  Filter,
  Replace,
}
